"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveItemScope = void 0;
const types_1 = require("../../types");
const sqlDynamicSchemaTools_1 = require("../utils/sqlDynamicSchemaTools");
const resolveScope_1 = require("../utils/resolveScope");
const utils_1 = require("../utils/utils");
const tools_1 = require("../../tools");
const resolveItemScope = (metaExpression, options) => {
    const { item, list, get_options_label, scolParams, mxolParams } = options;
    if (metaExpression.scope !== types_1.META_EXPRESSION_SCOPE.ITEM)
        throw new tools_1.InternalError("MetaExpression Scope not align.");
    if (!list || !item)
        return (0, utils_1.getMeResultNoResult)();
    const schema = (0, sqlDynamicSchemaTools_1.extractActivityOrListSchema)(list, true);
    return (0, resolveScope_1.resolveScopeWithSchema)(metaExpression, {
        object: item,
        schema,
        get_options_label,
        scolParams,
        mxolParams
    });
};
exports.resolveItemScope = resolveItemScope;
